import React, { memo } from 'react';
import { getConfig } from '@utils/config-utils';
import UnstyledHeading from '@shared/unstyled-heading';
import './city.scss';

const City = () => (
  <div>
    <div styleName="header-city-separator" />
    <UnstyledHeading rank={1} styleName="header-city-container">{getConfig().cityName}</UnstyledHeading>
  </div>
);

export default memo(City);
